import { useState, useCallback, useEffect } from "react";
import { debounce } from "lodash";

const useDebounce = (delay) => {
  const [deferredValue, setDeferredValue] = useState("");
  const [value, setValue] = useState("");

  const setDeferredValueDebounced = useCallback(
    debounce(setDeferredValue, delay),
    []
  );

  useEffect(() => {
    setDeferredValueDebounced(value);
  }, [value]);

  return {
    setValue,
    value,
    deferredValue,
  };
};

export default useDebounce;
